import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { VFC } from "react";
import { useNavigate } from "react-router-dom";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import BusinessIcon from "@mui/icons-material/Business";
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import MonitorIcon from '@mui/icons-material/Monitor';
import RouterIcon from '@mui/icons-material/Router';
import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";

type Props = {
  buttonName: string; // ボタン名
  linkPage: string; // ボタンのリンク先ページ名
  index: number; // 並び
  isSelected: boolean; // 現在表示中フラグ
  height?: number | string; // 1つのボタンの高さ
};

const SideMenuButton: VFC<Props> = ({
  buttonName,
  linkPage,
  index,
  isSelected,
  height,
}) => {
  const navigate = useNavigate();
  const buttonClick = () => {
    navigate(linkPage);
  };

  return (
    <ListItem disablePadding>
      <ListItemButton 
        onClick={buttonClick} 
        selected={isSelected}
        sx={{ 
          height: height,
          ":hover": {
            "& > .MuiListItemIcon-root": {
              color: "#ffff",
            },
            backgroundColor: "#6aff",
            color: "#ffff",
          },
          "&.Mui-selected": {
            "& > .MuiListItemIcon-root": {
              color: "#ffff",
            },
            backgroundColor: "#37cf",
            color: "#ffff",
          },
          "&.Mui-selected:hover": {
            "& > .MuiListItemIcon-root": {
              color: "#ffff",
            },
            backgroundColor: "#26bf",
            color: "#ffff",
          } 
        }}
      >
        <ListItemIcon>
          {index === 0 && <BusinessIcon fontSize="large"/>}
          {index === 1 && <HistoryEduIcon fontSize="large"/>}
          {/** 未実装 */}
          {index === 2 && <RouterIcon fontSize="large"/>}
          {index === 3 && <SwitchAccountIcon fontSize="large"/>}
          {/* {index === 3 && <MonitorIcon />} */}
        </ListItemIcon>
        <ListItemText primary={buttonName} />
      </ListItemButton>
    </ListItem>
  );
};

export default SideMenuButton;